import { ProductSearchResultItem, SearchResultGroup } from '../globalSearch.types';

const PRODUCT_ENTITY_TYPE = 'product';

export const mergeProductCodeResults = (
  groups: SearchResultGroup[],
  productCodeItems: ProductSearchResultItem[],
): SearchResultGroup[] => {
  if (productCodeItems.length === 0) {
    return groups;
  }

  const productGroup = groups.find((group) => group.entityType === PRODUCT_ENTITY_TYPE);
  const existingItems = productGroup?.items ?? [];
  const existingById = new Map(existingItems.map((item) => [item.id, item]));
  const matchedIds = new Set<string>();
  const seenCodeItemIds = new Set<string>();

  const promotedItems = productCodeItems
    .filter((codeItem) => {
      if (seenCodeItemIds.has(codeItem.id)) {
        return false;
      }
      seenCodeItemIds.add(codeItem.id);
      return true;
    })
    .map((codeItem) => {
      const existingItem = existingById.get(codeItem.id);
      if (!existingItem) {
        return codeItem;
      }
      matchedIds.add(codeItem.id);
      return { ...existingItem, colors: codeItem.colors };
    });

  const remainingItems = existingItems.filter((item) => !matchedIds.has(item.id));

  const mergedGroup: SearchResultGroup = {
    entityType: PRODUCT_ENTITY_TYPE,
    total: (productGroup?.total ?? 0) + promotedItems.length - matchedIds.size,
    hasMore: productGroup?.hasMore ?? false,
    items: [...promotedItems, ...remainingItems],
  };

  if (!productGroup) {
    return [...groups, mergedGroup];
  }

  return groups.map((group) => (group.entityType === PRODUCT_ENTITY_TYPE ? mergedGroup : group));
};
